module.exports = __webpack_public_path__ + "static/img/a123.be77f65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a123.jpg
// module id = TAhq
// module chunks = 0